<script lang="ts">
	import createCalendar from '$lib/components/DatePicker/calendar';
	import { onMount } from 'svelte';
	import { getHubStores } from '$lib/stores/hubStores';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import type { Instance } from 'flatpickr/dist/types/instance';
	const { hub } = getHubStores();

	export let disabled = false;
	export let value: string;
	export let setMaxDate = false;

	let dateValue = value ? new Date(value) : null;
	let target: HTMLElement;
	let calendar: Instance;

	let selectedDates: Date[];

	onMount(() => {
		if (target && !disabled) {
			calendar = createCalendar({
				lang: $hub.locale,
				target,
				defaultDate: dateValue || new Date(),
				...(setMaxDate && { maxDate: new Date() }),
				onChange: () => {
					selectedDates = calendar.selectedDates;
				},
			});
		}
	});

	$: dateValue = selectedDates ? selectedDates[0] : dateValue;
	$: value = dateValue ? dateValue.toISOString() : value;
	$: displayDate = () => {
		if (!dateValue) return '';
		return dateValue.toLocaleDateString($hub.locale, {
			year: 'numeric',
			day: 'numeric',
			month: 'long',
		});
	};
</script>

<div class="wrapper" class:disabled bind:this={target}>
	<div class="date">{displayDate()}</div>
	<div class="icon">
		<Icon icon="calendar" size="24" color={disabled ? 'grey' : 'black'} clickable />
	</div>
</div>

<style>
	.wrapper {
		display: flex;
		align-items: center;
		block-size: 3.7rem;
		padding: var(--gutterSmaller);
		border: 1px solid rgb(204 204 204);
		border-radius: 4px;
		font-size: var(--fontSizeSmall);
	}

	.date {
		flex: 1;
	}

	.icon {
		justify-self: end;
	}

	.disabled {
		border: 1px solid var(--grayLight);
		background-color: var(--grayLightest);
		color: var(--grayLight);
		pointer-events: none;
	}
</style>
